export default __webpack_public_path__ + "static/media/My Homeoffice.8bba91aa.jpg";